<script setup lang="ts">
import { ShopCore } from "@/abilities/shop/types/shop-core";
import { computed } from "vue";
import ShowPriceWithCurrency from "../../components/show-price-with-currency.vue";
import { useShopStatusStore } from "../../store/shop-status.store";
import AvailabilityIndicator from "../availability-indicator.vue";

// props
const props = defineProps<{
    flat: boolean;
    infoItem: ShopCore.WidgetItem | null;
}>();

const store = useShopStatusStore();

const isAvailableWithPrice = computed(() => {
    const item = props.infoItem;
    return store.isShopLight
        ? item !== null && item.price.amount !== null && item.price.amount >= 0 && item.price.currency !== null
        : item !== null && item.price.amount !== null && item.price.onRequestOnly === false;
});
</script>
<template>
    <div :class="{ 'space-between-flex': !flat, 'availability-indicator-flat': flat }">
        <AvailabilityIndicator v-if="!store.isShopLight" :info-item="infoItem" />
        <div
            v-if="isAvailableWithPrice"
            :class="{
                'to-the-right': !flat && store.isShopLight,
                'column full-height justify-between': flat && store.isShopLight,
            }"
        >
            <div v-if="store.isShopLight && flat" class="list-price">{{ $t("shop.list price") }}</div>
            <ShowPriceWithCurrency
                :class="{ 'price-single-product': !flat, 'price-single-product-flat': flat }"
                :pre-label="store.isShopLight && !flat ? $t('shop.list price') : undefined"
                :price="infoItem?.price.amount ?? null"
                :currency="infoItem?.price.currency"
                :convert-to-decimal="store.isShopLight"
                :use-currency-symbol="store.isShopLight"
            />
        </div>
        <div v-else :class="{ 'to-the-right': !flat && store.isShopLight, 'to-the-bottom': flat && store.isShopLight }">
            {{ store.isShopLight ? $t("shop.price on request") : $t("shop.No price available") }}
        </div>
    </div>
</template>
<style lang="scss" scoped>
.space-between-flex {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: $spacing-l;
}
.price-single-product {
    font-size: $bigger-font-size;
    color: $text-color-default;
    font-weight: $semi-bold;
}
.price-single-product-flat {
    font-size: 22px;
    color: $text-color-default;
}
.list-price {
    font-size: 12px;
    color: $grey-30;
}
.to-the-right {
    margin-left: auto;
}
.to-the-bottom {
    margin-top: auto;
}
.availability-indicator-flat {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
</style>
